import { useConversationData } from '~/composables/main';
import { useConversationActiveId } from '~/composables/main';
import { useServiceData } from '~/composables/main';
import { useIsDuringAIMessage } from '~/composables/main';
import { ModelConversationDetailMessage, ModelPOSTConversationAssociationConversationFile, ModelSource } from '~/services/conversation/dto/conversation.detail.dto';
import Prism from 'prismjs';


export async function streamConversationSSE(
  dataList: AsyncIterable<any>,
  mode: 'initial' | 'append' = 'initial',
  message?: string,
  filesList: any[] = []
) {
  const { $functions } = useNuxtApp();
  const gConversationData = useConversationData();
  const gConversationActiveId = useConversationActiveId();
  const gIsDuringAIMessage = useIsDuringAIMessage();
  const gServiceData = useServiceData();
  const gIsLimit = useIsLimit();
  const gLimitMessage = useLimitMessage();

  try {
    
    let index = 0;
    for await (const data of dataList) {
      console.log('SSE streamConversationSSE data', data);
      // data is parsed SSE payload (same shape as NATS messages)
      if (mode === 'append' && index === 0) {
        gConversationData.value.conversationMessageList.push(new ModelConversationDetailMessage({
          ...data,
          id: data.conversationMessageId,
          humanMessage: message || '',
          files: filesList,
        }));

        // console.log('SSE streamConversationSSE append add message', gConversationData.value.conversationMessageList);
      }
      switch (data.eventType) {
        case 'message-agent':
        case 'message-output':
          break;
        case 'message-start':
        case 'message-end':
        case 'message-stream':
          gConversationData.value.conversationMessageList =
            gConversationData.value.conversationMessageList.map((e) => {
              if (e.id === data.conversationMessageId) {
                if (data.value?.text) {
                  e.aiMessage = $functions.convertMarkdownToHtml(
                    `${e.aiMessage || ''}${data.value.text}`
                  );
                  e.aiMessageList.push(data.value.text);
                  e.isNewAIMessage = true;
                }
                if(data.value?.sources) {
                  e.sourceList = (data.value?.sources || []).map((s:any) => new ModelSource(s));
                }
                if(data.value?.isGenerateImage) {
                  e.isGenerateImage = true;
                  e.isNewAIMessage = false;
                }
                if (data.eventType === 'message-end') {
                  e.aiMessage = $functions.convertMarkdownToHtml(
                    e.aiMessage || '',
                    { isEndStream: true }
                  );
                  e.isEndStream = true;
                  e.generatedImagesList = (data.value?.genImage || []).map((img:any) => new ModelPOSTConversationAssociationConversationFile(img));
                  e.isMaxToken = data.value?.isMaxToken || false;
                }
              } else {
                e.isNewAIMessage = false;
              }
              return e;
            });

          if (data.eventType === 'message-end') {
            setTimeout(() => {
              Prism.highlightAll();
            }, 100);
            gIsDuringAIMessage.value = false;
            // if(data.value?.isLimit && data.value?.quotaWarning){
            if(data.value?.quotaWarning){
              $functions.notify.info({text: data.value.quotaWarning});
              gLimitMessage.value = data.value.quotaWarning;
              if(data.value?.isLimit) {
                  gIsLimit.value = true;
              }
            }
          }
          break;
        case 'title':
          gConversationActiveId.value = gConversationData.value.id;
          await gServiceData.value.getConversarion();
          break;
        case 'message-event':
          gConversationData.value.conversationMessageList =
            gConversationData.value.conversationMessageList.map((e) => {
              if (e.id === data.conversationMessageId) {
                let isReplace = false;
                e.processList = e.processList.map((ep) => {
                  if (
                    (ep.title || '').toLowerCase() ===
                      (data.value.title || '').toLowerCase() &&
                    e.processPreviousTitle === data.value.title
                  ) {
                    ep = data.value;
                    isReplace = true;
                  }
                  return ep;
                });
                if (!isReplace) {
                  e.processList.push(data.value);
                }
                e.processPreviousTitle = data.value.title;
                e.processHeader = data.value.title;
              }

              if(data.value.title === "Generating image") {
                e.isGenerateImage = true;
              }
              return e;
            });
          break;
      }
      index += 1;
    }
    console.log('SSE streamConversationSSE end', gConversationData.value.conversationMessageList);
  } catch (err: any) {
    console.error('SSE initialConversation error', err);
    // Handle abort error
    if (err.name === 'AbortError') {
      console.log('Stream was aborted by user');
      gIsDuringAIMessage.value = false;
      $functions.notify.info({
        text: 'Stream stopped'
      });
    }
  }
}